import { Spinner } from './Spinner'

interface PageLoadingProps {
  message?: string
}

/**
 * Full-page centered loading spinner.
 * Fills the entire viewport with a centered Spinner and optional message.
 */
export function PageLoading({ message }: PageLoadingProps) {
  return (
    <div
      className="
        flex min-h-[60vh] flex-col items-center justify-center
      "
      data-testid="page-loading"
      role="status"
      aria-live="polite"
    >
      <Spinner size="lg" />
      {message && (
        <p className="mt-4 text-sm text-[var(--color-text-secondary)]">
          {message}
        </p>
      )}
    </div>
  )
}
